export default {"src":"/_next/static/media/LITE.33786f0e.svg","height":18,"width":18};